import { post } from "../utils/http";
export default {
  async getListCategory (param) {
    return await post('/goodsCategory/goodsCategoryList', param);
  },
  async getGoodsList(data) {
    return await post("/goods/goodsList", data);
  },
  async getGoodsIsShowTime(data) {
    return await post("/goodsCategory/goodsCategoryIsShow", data);
  },
  async getGoodsCategoryById (param, disibleLoading) {
    return await post('/goodsCategory/goodsCategoryById', param, disibleLoading);
  },
};
